import { render, staticRenderFns } from "./TaxRegistration.vue?vue&type=template&id=72edb228&scoped=true"
import script from "./TaxRegistration.vue?vue&type=script&lang=js"
export * from "./TaxRegistration.vue?vue&type=script&lang=js"
import style0 from "./TaxRegistration.vue?vue&type=style&index=0&id=72edb228&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72edb228",
  null
  
)

export default component.exports